import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Output, EventEmitter, Input, HostListener } from '@angular/core';
import { EmployeeInformationService } from 'src/app/data-analysis-summary/employee-information/employee-information.service';
import { Subject, Subscription, debounceTime, switchMap } from 'rxjs';
import { RightSideDrawerService } from 'src/app/shared/right-side-drawer/right-side-drawer.service';
import { SessionService } from 'src/app/shared/session-service/session.service';
import { Modal_Constants } from 'src/app/shared/constants/app-constants';
import { ManageStudyService } from 'src/app/manage-study/manage-study.service';
import { LegalEntitiesService } from 'src/app/data-analysis-summary/legal-entity/legal-entity.service';
import { ModalService } from '../../../shared/modal/modal.service';
import { Project } from '../../../shared/models/project.model';
import { BusinessComponentService } from './../business-component.service';
import { BusinessComponentDetail, ClientProject } from '../models/client-project.model';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProjectSurveys } from '../models/business-component-response.model';
import { BusinessComponent } from '../business-components.component';

@Component({
    selector: 'manage-business-component-screen',
    templateUrl: './manage-business-component-screen.component.html',
    styleUrls: ['./manage-business-component-screen.component.scss'],
})
export class ManageBusinessComponent implements OnInit, OnDestroy {
    masterCheckboxControl: boolean = false;
    isArchived: any = this.sessionService.getSession('isArchived');
    selectedProjects: ClientProject[] = [];
    isSelected: boolean = false;
    isAssigned: boolean = false;
    bcSurvey: boolean = false;
    subscriptions: Subscription[] = [];
    engagement: any;
    @ViewChild('eiGeneratedTableElement', { static: true })
    eiGeneratedTableElement: ElementRef;
    hasEngagementDetails: boolean = false;
    studyId = 0;
    tableDataFilteredCopy: Project[];
    @ViewChild('inserttarget', { static: false })
    public insertTarget: ElementRef;
    initialCount: number;
    @Output() drawerWidth = new EventEmitter<any>();
    selectedBusinessCompId: number | null = null;
    selectedIndex: number = 0;
    projectCount: number = 0;
    filteredClientProject = [];
    selectedBusinessCompName: string = '';
    selectedBusinessCompQPercentage: number;
    selectedBcNumber: string = '';
    selectedBcType: string = '';
    searchQuery: string = '';
    clientProjects: ClientProject[] = [];
    clientProjectsCopy: ClientProject[];
    projectSurveys: ProjectSurveys[] = [];
    businessCompOptions: BusinessComponentDetail[];
    projects: Project[] = [];
    businessComponents: BusinessComponentDetail[] = [];
    selectedBusinessComponent!: BusinessComponentDetail;
    private updateSubject = new Subject<BusinessComponentDetail>();
    isDeleteBizComp: boolean = false;
    isAddClientProject: boolean = false;
    showBCDialog: boolean = false;
    selectedBusinessCompIdToDelete: number | null = null;
    @Input() engagementId: number;
    submenuVisibility: boolean[] = [];
    isDeleteClientProj: boolean = false;
    selectedClientProjectId: number[] | null = null;
    isBulkActionsVisible: boolean = false;
    selectedBulkClientProjectId: number[] = [];
    bcTypes = [
        { value: 'Product', label: 'Product' },
        { value: 'Process', label: 'Process' },
        { value: 'Software', label: 'Software' }
    ];
    form: FormGroup;
    searchEnabled: boolean = false;
    totalProject: number;
    initialFormValues: any;
    currentProjectId: number = 0;
    showRowSubmenu: boolean;
    offset: number = 0;

    constructor(
        public rightSideDrawerService: RightSideDrawerService,
        public sessionService: SessionService,
        public _manageStudyService: ManageStudyService,
        public _legalEntitiesService: LegalEntitiesService,
        public employeeInformationService: EmployeeInformationService,
        private _modalService: ModalService,
        public _projectsService: BusinessComponentService,
        private fb: FormBuilder
    ) {
        this.updateSubject.pipe(
            debounceTime(1300),
            switchMap((detail) => this._projectsService.updateBusinessCompDetails(detail, this.engagementId))
        ).subscribe();
        this.initializeSubmenuVisibility();
    }

    loadProjectSurveys() {
        this._projectsService.projectSurveys$.subscribe((data) => {
            const prjtsurveys = [...data];
            this.projectSurveys = [...prjtsurveys]

            this.clientProjects.forEach(project => {

                const isProjectInSurveys = prjtsurveys.some(survey => survey.projectId === project.clientProjectId && survey.surveyCategoryId === 2);
                const isComponentInSurveys = prjtsurveys.some(survey => survey.projectId === project.businessComponentId && survey.surveyCategoryId === 2);

                // If the project ID is present, set the survey properties to true
                if (isProjectInSurveys) {
                    project.projectSurvey = true;

                }
                if (isComponentInSurveys) {
                    project.bcSurvey = true;
                }

                if (this.selectedBusinessCompId != null) {
                    const selectedIndex = this.businessComponents.findIndex(
                        bc => bc.businessComponentId === this.selectedBusinessCompId
                    );
                    if (selectedIndex !== -1) {
                        this.selectBizComp(this.businessComponents[selectedIndex], selectedIndex);
                    }
                }
            });

            this.businessComponents = this.businessComponents.map(bc => {
                return {
                    ...bc,
                    hasQualitativeSurvey: this.hasQualtitaiveSurvey(bc),
                    isAllocated: this.hasQualtitaiveSurvey(bc) ? true : bc.isAllocated
                }
            })
        })
    }

    hasQualtitaiveSurvey(bc: BusinessComponentDetail): boolean {
        const hasQS = this.projectSurveys.some(x => x.projectId === bc.businessComponentId) &&
            this.projectSurveys[this.projectSurveys.findIndex(x => x.projectId === bc.businessComponentId)]?.surveyId > 0 ?
            true : false
        return hasQS;
    }

    ngOnInit(): void {
        this.isArchived = this.sessionService.getSession('isArchived');
        this._projectsService.businessComponentsprojects$.subscribe(data => {
            const prjts = data.flatMap(x => x.clientProjectsDTOs);
            const businessCompDetail: BusinessComponentDetail[] = data.map(item => ({
                businessComponentId: item.businessComponentId,
                businessComponentName: item.businessComponentName,
                businessComponentQPercentage: item.businessComponentQPercentage,
                businessComponentType: 1,
                bcNumber: item.bcNumber,
                bcType: item.bcType,
                isAllocated: item.isAllocated,
                hasQualitativeSurvey: false
            }));
            const project = prjts.map(prj => {
                const businessComponent = businessCompDetail.find(x => x.businessComponentId === prj.businessComponentId);
                return {
                    clientProjectId: prj.projectId,
                    clientProjectname: prj.projectName,
                    clientProjectNumber: prj.projectNumber,
                    projectQPercentage: prj.projectQPercentage,
                    Description: prj.description,
                    clientProjectType: prj.projectType,
                    businessComponentDetail: businessCompDetail,
                    allocated: prj.isAllocated,
                    isSelected: false,
                    businessComponentId: businessComponent ? businessComponent.businessComponentId : null,
                    businessComponentQPercentage: businessComponent ? businessComponent.businessComponentQPercentage: null,
                    bcNumber: businessComponent ? businessComponent.bcNumber : null,
                    bcType: businessComponent ? businessComponent.bcType : null,
                    projectSurvey: false,
                    bcSurvey: prj.bcSurvey
                };
            }).filter(prj => prj.businessComponentId !== null);

            this.clientProjects = [...project];
            this.businessComponents = businessCompDetail.sort((a, b) => {
                if (a.businessComponentName < b.businessComponentName) {
                    return -1;
                }
                if (a.businessComponentName > b.businessComponentName) {
                    return 1;
                }
                return 0;
            }).filter(prj => prj.businessComponentId !== null);

            this.form = this.fb.group({
                businessCompName: ['', [Validators.required, Validators.maxLength(50), this.uniqueNameValidator.bind(this)]],
                businessCompQPercentage: ['', [Validators.required, Validators.min(0), Validators.max(100)]],
                bcNumber: ['', [Validators.required, Validators.maxLength(20), this.uniqueNumberValidator.bind(this)]],
                bcType: ['', Validators.required]
            });

            this._projectsService.projectSurveys$.subscribe((data) => {
                const prjtsurveys = [...data];
                this.projectSurveys = [...prjtsurveys]

                this.clientProjects.forEach(project => {

                    const isProjectInSurveys = prjtsurveys.some(survey => survey.projectId === project.clientProjectId && survey.surveyCategoryId === 2);
                    const isComponentInSurveys = prjtsurveys.some(survey => survey.projectId === project.businessComponentId && survey.surveyCategoryId === 2);

                    // If the project ID is present, set the survey properties to true
                    if (isProjectInSurveys) {
                        project.projectSurvey = true;

                    }
                    if (isComponentInSurveys) {
                        project.bcSurvey = true;
                    }

                    if (this.selectedBusinessCompId != null) {
                        const selectedIndex = this.businessComponents.findIndex(
                            bc => bc.businessComponentId === this.selectedBusinessCompId
                        );
                        if (selectedIndex !== -1) {
                            this.selectBizComp(this.businessComponents[selectedIndex], selectedIndex);
                        }
                    }
                });

                if (this.businessComponents.length > 0) {
                    const selectedComponent = this.businessComponents[this.selectedIndex];
                    if (selectedComponent && selectedComponent.businessComponentId === this.selectedBusinessCompId) {
                        this.selectBizComp(selectedComponent, this.selectedIndex);
                    } else {
                        this.selectBizComp(this.businessComponents[0], 0);
                    }
                }

                this.businessComponents = this.businessComponents.map(bc => {
                    return {
                        ...bc,
                        hasQualitativeSurvey: this.hasQualtitaiveSurvey(bc),
                        isAllocated: this.hasQualtitaiveSurvey(bc) ? true : bc.isAllocated
                    }
                })
            })
        });

        this.filteredClientProject = this.clientProjects;
        if (this.businessComponents.length > 0) {
            this.selectBizComp(this.businessComponents[0], 0);
        }

        this.form.valueChanges.subscribe(() => {
            this.hasFormChanged();
        });
        this.drawerWidth.emit("1105px");

    }

    onSubmit() {
        if (this.form.valid && this.hasFormChanged()) {
            const formValues = this.form.value;
            this.updateBizCompDetail(
                formValues.businessCompQPercentage,
                formValues.businessCompName,
                formValues.bcNumber,
                formValues.bcType,
                this.selectedBusinessCompId
            );
            console.log('Form Submitted', this.form.value);
        } else {
            console.log('Form is invalid');
        }
    }

    onModelChange(value: string): void {
        this.selectedBusinessCompName = value;
    }

    getRowClass(): string {
        return 'apply-italics'
    }
    checkIfAssignedToSurvey(businessComponentId: number): boolean {
        return this.clientProjects.some(project => project.businessComponentId === businessComponentId && project.allocated);
    }
    checkIfAssignedTobcSurvey(businessComponentId: number): boolean {
        return this.clientProjects.some(project => project.businessComponentId === businessComponentId && project.bcSurvey);
    }

    selectBizComp(option: BusinessComponentDetail, index: number) {
        this.selectedBusinessComponent = option;
        this.selectedIndex = index;
        this.selectedBusinessCompId = option.businessComponentId;
        this.selectedBusinessCompName = option.businessComponentName;
        this.selectedBusinessCompQPercentage = option.businessComponentQPercentage;
        this.selectedBcNumber = option.bcNumber;
        this.selectedBcType = option.bcType;
        this.isAssigned = this.checkIfAssignedToSurvey(option.businessComponentId);
        this.bcSurvey = this.checkIfAssignedTobcSurvey(option.businessComponentId);

        this.form.patchValue({
            businessCompName: this.selectedBusinessCompName,
            businessCompQPercentage: this.selectedBusinessCompQPercentage,
            bcNumber: this.selectedBcNumber,
            bcType: this.selectedBcType
        });

        this.initialFormValues = this.form.value;
        this.totalProject = 0;
        this.searchEnabled = false;
        this.filterClientProjects();
        if (this.searchQuery != '') {
            this.searchProjectData(this.searchQuery);
        }
        this.masterCheckboxControl = true;
        this.selectMultiple();
    }

    filterClientProjects() {
        if (this.selectedBusinessCompId !== null) {
            this.filteredClientProject = this.clientProjects.filter(project =>
                project.businessComponentId == this.selectedBusinessCompId
            );
        } else {
            this.filteredClientProject = this.clientProjects.filter(project =>
                project.businessComponentId !== this.selectedBusinessCompId
            );
        }
        this.filteredClientProject.sort((a, b) => {
            if (a.clientProjectname < b.clientProjectname) {
                return -1;
            }
            if (a.clientProjectname > b.clientProjectname) {
                return 1;
            }
            return 0;
        });

    }

    searchProjectData(query: string) {
        this.searchEnabled = true;
        this.searchQuery = query;
        this.filterClientProjects();
        const originalFilteredClientProject = [...this.filteredClientProject];
        this.totalProject = originalFilteredClientProject.length;
        if (query) {
            this.filteredClientProject = this.filteredClientProject.filter(item =>
                (item.clientProjectname?.toLowerCase().includes(query.toLowerCase()) ?? false) ||
                (item.clientProjectNumber?.toLowerCase().includes(query.toLowerCase()) ?? false) ||
                (item.Description?.toLowerCase().includes(query.toLowerCase()) ?? false)
            );
        }
    }

    onSearchChange(query: string) {
        this.searchQuery = query;
        this.filterClientProjects();
    }

    clearSearch() {
        this.searchQuery = '';
    }

    getFilteredCountAndPercentage(optionId: number) {
        const count = this.clientProjects.reduce((item, project) => {
            const hasMatchingComponent = project.businessComponentId === optionId;
            return hasMatchingComponent ? item + 1 : item;
        }, 0);

        this.projectCount = count;
        return { count };
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    updateBizCompDetail(qPercentage: number, name: string, bcNumber: string, bcType: string, id: number): void {
        const updateBusinessCompDetail: BusinessComponentDetail = {
            businessComponentId: id,
            businessComponentName: name,
            businessComponentQPercentage: qPercentage,
            businessComponentType: 1,
            bcNumber: bcNumber,
            bcType: bcType,
            isAllocated: false,
            hasQualitativeSurvey: false
        };

        this.updateSubject.next(updateBusinessCompDetail);
    }

    selectSingle(row: ClientProject, isSelected: boolean) {
        if (isSelected === true) {
            this.selectedProjects.push(row);
        } else {
            let filteredProject = this.selectedProjects.filter(item => item.clientProjectId !== row.clientProjectId);
            this.selectedProjects = [];
            this.selectedProjects = filteredProject;
            this.masterCheckboxControl = false;
        }
        this.selectedBulkClientProjectId = this.selectedProjects.map(x => x.clientProjectId);
    }

    selectMultiple() {
        this.masterCheckboxControl = !this.masterCheckboxControl;
        if (this.masterCheckboxControl === true) {
            if (this.searchQuery != '') {
                this.selectedProjects = this.filteredClientProject;
            } else {
                this.selectedProjects = this.clientProjects.filter(
                    item => item.allocated === false && item.businessComponentId === this.selectedBusinessCompId
                );
            }
            this.selectedBulkClientProjectId = this.selectedProjects.map(x => x.clientProjectId);
        } else {
            this.selectedProjects = [];
        }
    }

    trimGridValue(inputValue: string, maxLength: number): string {
        return inputValue !== null
            ? (inputValue.length >= maxLength
                ? inputValue.substring(0, maxLength).trimRight() + '...'
                : inputValue)
            : ''
    }

    openDeleteBusinessCompConfirmBox(): void {
        this.selectedBusinessCompIdToDelete = this.selectedBusinessCompId;
        this.isDeleteBizComp = true;
        this._modalService.open('delete-biz-comp-modal');
    }

    openAddClientProj(): void {
        this.isAddClientProject = true;
        this._modalService.close('add-client-proj-modal');
    }

    showCreateBusinessComponentDialog(): void {
        this.rightSideDrawerService.openRightSideDrawer('create-business-component', 'Create New Business Component',
            { studyId: this.engagementId });
    }

    closeBCDialog(): void {
        this.showBCDialog = false;
    }

    closeModal(modal: string) {
        if (modal == Modal_Constants.DELETEBUSINESSCOMPONENT) {
            this.isDeleteBizComp = false;
            this._modalService.close('delete-biz-comp-modal');
        } else if (modal == Modal_Constants.ADDEXISTINGCLIENTPROJECT) {
            this.isAddClientProject = false;
            this._modalService.close('add-client-proj-modal');
            this.loadProjectSurveys();
            if (this.selectedBusinessCompId != null) {
                this.bcSurvey = this.checkIfAssignedTobcSurvey(this.selectedBusinessCompId);
            }
        }
        else if (modal == 'remove-client-proj-modal') {
            this.isDeleteClientProj = false;
            this._modalService.close('remove-client-proj-modal');
        }
    }

    //bulk action

    toggleBulkActions(event: Event): void {
        event.preventDefault();
        this.isBulkActionsVisible = !this.isBulkActionsVisible;
    }

    //ends

    //remove CP 
    initializeSubmenuVisibility(): void {
        this.submenuVisibility = new Array(this.filteredClientProject.length).fill(false);
    }

    toggleMenu(event: MouseEvent, rowIndex: number, row: any, elem: any): void {
        event.preventDefault();
        event.stopPropagation();
        this.submenuVisibility = this.submenuVisibility.map(() => false);
        this.submenuVisibility[rowIndex] = !this.submenuVisibility[rowIndex];

        this.currentProjectId = row.clientProjectId;
        this.showRowSubmenu = !this.showRowSubmenu;
        this.offset = elem.getBoundingClientRect().top + 24;
    }

    isMenuOpen(rowIndex: number): boolean {
        return this.submenuVisibility[rowIndex];
    }

    closeMenu(event: Event, rowIndex: number): void {
        event.stopPropagation();
        this.submenuVisibility[rowIndex] = false;
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event): void {
        const target = event.target as HTMLElement;
        this.showRowSubmenu = target.closest('.submenu-icon-button') != null
        const isClickInside = target.closest('.menu') || target.closest('.menu-icon') || target.closest('.bulk-actions');
        if (!isClickInside) {
            this.submenuVisibility = this.submenuVisibility.fill(false);
            this.isBulkActionsVisible = false;
        }
    }

    openDeleteClientProjectConfirmBox(projectId: number | number[]): void {
        this.selectedClientProjectId = Array.isArray(projectId) ? projectId : [projectId];
        this.isDeleteClientProj = true;
        this.submenuVisibility.fill(false);
        this._modalService.open('remove-client-proj-modal');
    }
    //ends

    getErrorMessage() {
        const errors = [];
        const businessCompNameErrors = this.form.get('businessCompName').errors;
        const businessCompQPercentageErrors = this.form.get('businessCompQPercentage').errors;
        const bcNumberErrors = this.form.get('bcNumber').errors;

        if (businessCompNameErrors) {
            if (businessCompNameErrors.nameNotUnique) {
                return 'Business Component Name must be unique.';
            }
            if (businessCompNameErrors.required) {
                errors.push('Business Component Name');
            }
        }

        if (businessCompQPercentageErrors) {
            if (businessCompQPercentageErrors.min || businessCompQPercentageErrors.max) {
                return 'Qualified Percentage must be a number between 0-100%.';
            }
            if (businessCompQPercentageErrors.required) {
                errors.push('Qualified Percentage');
            }
        }

        if (bcNumberErrors) {
            if (bcNumberErrors.numberNotUnique) {
                return 'BC Number must be unique.';
            }
            if (bcNumberErrors.required) {
                errors.push('BC Number');
            }
        }

        if (errors.length === 1) {
            return `${errors[0]} is a required field.`;
        } else if (errors.length > 1) {
            return `${errors.join(', ')} are required fields.`;
        } else {
            return '';
        }
    }

    hasFormChanged(): boolean {
        return JSON.stringify(this.form.value) !== JSON.stringify(this.initialFormValues);
    }

    uniqueNameValidator(control: AbstractControl): { [key: string]: boolean } | null {
        if (!control.value || !this.selectedBusinessCompId) {
            return null;
        }
        const isDuplicate = this.businessComponents.some(
            bc => bc.businessComponentName === control.value && bc.businessComponentId !== this.selectedBusinessCompId
        ) || this.clientProjects.some(
            cp => cp.clientProjectname === control.value
        );
        return isDuplicate ? { 'nameNotUnique': true } : null;
    }

    uniqueNumberValidator(control: AbstractControl): { [key: string]: boolean } | null {
        if (!control.value || !this.selectedBusinessCompId) {
            return null;
        }
        const isDuplicate = this.businessComponents.some(
            bc => bc.bcNumber === control.value && bc.businessComponentId !== this.selectedBusinessCompId
        ) || this.clientProjects.some(
            cp => cp.clientProjectNumber === control.value
        );
        return isDuplicate ? { 'numberNotUnique': true } : null;
    }

}
